import {Injectable, signal, WritableSignal} from '@angular/core';
import {Branch, Section, SubSection} from '../../graphql/generated';
import {DatabaseService} from './database.service';
import {StorageMap} from '@ngx-pwa/local-storage';
import {PrinterConfigService} from './printer-config.service';

@Injectable({
  providedIn: 'root',
})
export class SignalService {
  section: WritableSignal<Section> = signal({} as Section);
  subSections: WritableSignal<SubSection[]> = signal([]);
  branch: WritableSignal<Branch> = signal({} as Branch);

  constructor(
    private databaseService: DatabaseService,
    private printerConfigService: PrinterConfigService,
    private storage: StorageMap,
  ) {
    this.init();
  }

  async setSection(section: Section) {
    if (!section) return;
    this.section.set(section);
    const sortedSubSections = (section?.sub_sections || []).sort((a, b) => {
      return (a.listing_sequence || 0) - (b.listing_sequence || 0);
    });
    this.subSections.set(sortedSubSections);
    await this.databaseService.setOrdersOnSectionSelection(section);
    this.storage.set('selectedSection', section).subscribe();
  }

  async setBranch(branch: Branch) {
    this.branch.set(branch);
    this.storage.set('selectedBranch', branch).subscribe();
  }

  init() {
    this.storage.get('selectedSection').subscribe((section) => {
      if (section) {
        this.section.set(section as Section);
        this.subSections.set((section as Section).sub_sections || []);
      }
    });
    this.storage.get('selectedBranch').subscribe((branch) => {
      if (branch) {
        this.branch.set(branch as Branch);
      }
    });
    this.printerConfigService.handlePrinterConfig().then();
  }

  clear() {
    this.section.set({} as Section);
    this.subSections.set([]);
    this.branch.set({} as Branch);
    this.storage.delete('selectedSection').subscribe();
    this.storage.delete('selectedBranch').subscribe();
    localStorage.clear();
  }
}
